module.exports = __webpack_public_path__ + "static/media/Jay Shah.8d87a366.jpg";